
import { useMemo } from 'react';
import PowerPstyleSection from '@/components/help-center/powers/PowerPstyleSection';
import { getPowerBySlug, mergePowerWithMockExtras } from '@/lib/powers-data';
import type { AceInfo } from '@/lib/aces-data';
import { powerShowsPstyleSection } from '@/lib/power-pstyle-themes';

type AcePstyleSectionProps = {
  ace: AceInfo;
};

/** Secção Pstyle do Ace — tema CMS ou fallback built-in (ex.: Yellow → Sunburst). */
export function AcePstyleSection({ ace }: AcePstyleSectionProps) {
  const power = useMemo(() => {
    const base = getPowerBySlug(ace.slug);
    if (!base) return null;

    const merged = mergePowerWithMockExtras(base);

    if (ace.pstyleSectionEnabled) {
      const powerForSection = ace.pstyle ? { ...merged, pstyle: ace.pstyle } : merged;
      if (ace.pstyle || powerShowsPstyleSection(powerForSection)) {
        return powerForSection;
      }
      return null;
    }

    if (!powerShowsPstyleSection(merged)) return null;

    return merged;
  }, [ace]);

  if (!power) return null;

  return <PowerPstyleSection power={power} />;
}
